import { useLayoutEffect } from 'react';
import ErrorSummary from './ErrorSummary/ErrorSummary';
import ErrorSuggestion from './ErrorSuggestion/ErrorSuggestion';

import { Background, Content } from './ErrorPage.styles';

export enum ErrorCode {
  error403 = '403',
  error404 = '404',
  error500 = '500'
}

export interface IProps {
  errorCode: string;
}
const ErrorPage = ({ errorCode }: IProps) => {
  useLayoutEffect(() => {
    document.body.style.height = '100vh';

    return () => {
      document.body.style.height = '';
    };
  }, []);

  return (
    <Background>
      <Content>
        <ErrorSummary errorCode={errorCode} />
        <ErrorSuggestion errorCode={errorCode} />
      </Content>
    </Background>
  );
};

export default ErrorPage;
